import "./SuccessStories.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedCaseStudy from "./sections/FeaturedCaseStudy";
import ClientTestimonials from "./sections/ClientTestimonials";
import ResultsGallery from "./sections/ResultsGallery";
import Footer from "@/reusable_sections/Footer";
export default function SuccessStoriesPage() {
  return <div>
      <Header />
      <FeaturedCaseStudy />
      <ClientTestimonials />
      <ResultsGallery />
      <Footer />
    </div>;
}